import {dimensions} from 'helpers/dimensions';
import delay from 'helpers/delay';
import scrollToElement from 'helpers/scrollToElement';
import debounce from 'debounce';

'use strict';

var BundleList = function(bundleList, index) {
  var _this = this;

  _this.bundleList = bundleList;

  _this.idValue = "bundle-panel-list-" + index;

  _this.bundleList.setAttribute("id", _this.idValue);

  _this.height = _this.bundleList.getBoundingClientRect().height;
  _this.getOuterMargin = dimensions.getStyle(_this.bundleList, 'marginBottom');

  _this.bundleListItems = _this.bundleList.querySelectorAll('.bundle-panel');

  _this.contractedHeight = 0;

  _this.windowWidth = setWindowWidth();

  var maxVisibleBundles = _this.bundleListItems.length > 3 ? 3 : _this.bundleListItems.length;

  if( _this.windowWidth >= 768 ) {
    _this.contractedHeight = dimensions.getElementHeight(_this.bundleListItems[0], false);
  } else {
    for (var i = 0; i < maxVisibleBundles; i++) {
      _this.contractedHeight = _this.contractedHeight + dimensions.getElementHeight(_this.bundleListItems[i], false);
    }
  }

  _this.numberOfExtraBundles = countAdditionalBundles(_this.bundleListItems, maxVisibleBundles);

  if (_this.numberOfExtraBundles > 0) {

    _this.hiddenBundles = prepAdditionalBundles(_this.bundleListItems, maxVisibleBundles);

    _this.clicks = 0;

    _this.initialMessage = 'Show more bundles';
    _this.altMessage = 'Show fewer bundles';

    _this.expandButtonText = document.createTextNode(_this.initialMessage);

    _this.expandButton = document.createElement('button');
    _this.expandButton.appendChild(_this.expandButtonText);

    _this.expandButton.classList.add('bundle-list-toggle');
    _this.expandButton.classList.add('button', 'button--secondary');
    _this.expandButton.classList.add('button--expand');
    _this.expandButton.setAttribute('aria-expanded', false);
    _this.expandButton.setAttribute('aria-controls', _this.idValue);

    _this.expandButton.addEventListener('click', function(e) {
      _this.bundleList.classList.toggle('is-open');

      _this.clicks++;

      if (_this.clicks % 2 === 0) {
        _this.bundleList.style.height = ((_this.contractedHeight) - parseInt(_this.getOuterMargin)) + 'px';
        _this.expandButtonText.nodeValue = _this.initialMessage;
        _this.expandButton.classList.remove('button--contract');
        _this.expandButton.classList.add('button--expand');
        _this.expandButton.setAttribute('aria-expanded', false);
        toggleBundles(_this.hiddenBundles, {visibility: "hidden"});

        let location = document.querySelector('.bundle-panel-set-heading');
        scrollToElement(location);
      } else {
        _this.bundleList.style.height = _this.height + 'px';
        _this.expandButtonText.nodeValue = _this.altMessage;
        _this.expandButton.classList.remove('button--expand');
        _this.expandButton.classList.add('button--contract');
        _this.expandButton.setAttribute('aria-expanded', true);
        delay(250, function() {
          _this.hiddenBundles[0].querySelector('a').focus();
        });
        toggleBundles(_this.hiddenBundles, {visibility: "visible"});
      }

      e.preventDefault();
    });

    _this.bundleList.classList.add('is-js-enabled');
    _this.bundleList.style.height = ((_this.contractedHeight) - parseInt(_this.getOuterMargin)) + 'px';

    _this.bundleList.parentNode.insertBefore(_this.expandButton, _this.bundleList.nextSibling);

    window.addEventListener( 'resize', debounce(() => {
      _this.windowWidth = window.innerWidth;

      if ( _this.windowWidth >= 768 ) {
        _this.contractedHeight = dimensions.getElementHeight(_this.bundleListItems[0], false);
      } else {
        _this.contractedHeight = 0;
        for (var i = 0; i < maxVisibleBundles; i++) {
          _this.contractedHeight = _this.contractedHeight + dimensions.getElementHeight(_this.bundleListItems[i], false);
        }
      }

      if ( _this.clicks % 2 === 0 ) {
        _this.bundleList.style.height = _this.contractedHeight + 'px';
      } else {
        _this.height = _this.bundleList.getBoundingClientRect().height;
        _this.bundleList.style.height = _this.height + 'px';
      }
    }));
  }
};

function countAdditionalBundles(listItems, maxVisible) {
  var listItemCount = listItems.length;

  return Math.max(0, listItemCount - maxVisible);
}

function prepAdditionalBundles(listItems, visibleItemCount) {
  var preppedListItems = [];
  for (var i = visibleItemCount; i < listItems.length; i ++) {
    listItems[i].setAttribute('aria-hidden', 'true');
    preppedListItems.push(listItems[i]);
  }
  return preppedListItems;
}

function toggleBundles(bundles, args) {
  [].forEach.call(bundles, function(bundle){
    if (args.visibility === 'hidden'){
      bundle.setAttribute('aria-hidden', true);
    } else {
      bundle.setAttribute('aria-hidden', false);
    }
  });
}

function setWindowWidth() {
  return window.innerWidth;
}

function init() {
  var activeBundleLists = [];
  var bundleLists = document.querySelectorAll('.bundle-panel-list');
  [].forEach.call(bundleLists, function(list, index) {
    activeBundleLists.push(new BundleList(list, index));
  });
}

if ('querySelector' in document) {
  init();
}
